import moment from "moment";

export default {
  methods: {
    dayFormatLLAndTime(date) {
      return !date ? "" : `${this.dayFormatLL(date)} ${this.formatTime(date)}`;
    },
    dayFormatLLAndTime2(date) {
      return !date
        ? ""
        : `${this.dayFormatLL2(date)} ${this.formatTime2(date)}`;
    },
    formatDateTime(date) {
      return !date ? "" : `${this.formatDate(date)} ${this.formatTime(date)}`;
    },
    formatDate(date) {
      return !date ? "" : moment(this.unixTimestamp(date)).format("DD/MM/yyyy");
    },
    formatTime(date) {
      return !date ? "" : moment(this.unixTimestamp(date)).format("HH:mm:ss");
    },
    formatDateTime2(date) {
      return !date
        ? ""
        : `${moment(date).format("DD/MM/yyyy")} ${this.formatTime2(date)}`;
    },
    formatTime2(date) {
      return !date ? "" : moment(date).format("HH:mm:ss");
    },
    dayFormatLL(date) {
      return !date ? "" : moment(this.unixTimestamp(date)).format("ll");
    },
    dayFormatLL2(date) {
      return date === undefined || !date ? "" : moment(date).format("ll");
    },
    dayFormat2(date) {
      return date === undefined || !date
        ? ""
        : moment(date).format("DD/MM/yyyy");
    },
    yearFormat1(date) {
      return date === undefined || !date ? "" : moment(date).format("yyyy");
    },
    unixTimestamp(date) {
      return date.seconds * 1000;
    },
    getTotalPrice(order) {
      let total = 0;
      order.forEach(item => {
        if (item.isMenuGroupProduct) {
          item.starters.forEach(starter => {
            total += parseFloat(starter.additional_charge) * item.quantity;
          });
          item.maincourse.forEach(main => {
            total += parseFloat(main.additional_charge) * item.quantity;
          });
          item.desserts.forEach(dessert => {
            total += parseFloat(dessert.additional_charge) * item.quantity;
          });
          item.drinks.forEach(drink => {
            total += parseFloat(drink.additional_charge) * item.quantity;
          });
        }
        total += item.quantity * item.price;
      });
      return total;
    },
    uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      );
    }
  }
};
